import BaseAPIHelper from 'services/BaseAPIHelper';
export const getWeChatSignature = (input) => {
  const url = `/we-chat/signature`;
  return BaseAPIHelper.post({ link: url, input });
};

export const getWeChatMPMessageSubscribed = (input) => {
  const url = `/we-chat/mp-check-message-subscribed`;
  return BaseAPIHelper.post(
    {
      link: url,
      input,
    })
};
